export default __webpack_public_path__ + "static/media/furniture11.b41fb63e.jpeg";